"use client"

import { useEffect } from "react"
import { useRouter } from "@/lib/navigation"

import { useAuth } from "@/contexts/auth-context"
import { ThemeToggle } from "@/components/theme-toggle"
import { SessionRetry } from "@/components/session-retry"
import { LoginForm } from "@/components/login-form"
import { Card, CardContent, CardHeader } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

export default function LoginPage() {
  const router = useRouter()
  const {
    isAuthenticated,
    userType,
    isLoading,
    sessionError,
    refreshSession,
    logout,
  } = useAuth()

  // 已登录则跳转到对应面板
  useEffect(() => {
    if (!isLoading && isAuthenticated && userType) {
      router.replace(`/${userType}/dashboard`)
    }
  }, [isAuthenticated, userType, isLoading, router])

  // 兜底：token 存在但身份缺失属于不一致状态，
  // 若不清除会永久停留在“正在跳转”而无法操作。
  useEffect(() => {
    if (!isLoading && isAuthenticated && !userType) {
      logout()
    }
  }, [isLoading, isAuthenticated, userType, logout])

  useEffect(() => {
    localStorage.removeItem("savedUserForm")
    localStorage.removeItem("savedAdminForm")
    localStorage.removeItem("savedProUserForm")
  }, [])

  if (isLoading) {
    return (
      <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
        <div className="w-full max-w-sm">
          <Card>
            <CardHeader>
              <Skeleton className="h-6 w-32" />
              <Skeleton className="h-4 w-full" />
            </CardHeader>
            <CardContent className="flex flex-col gap-4">
              <Skeleton className="h-9 w-full" />
              <Skeleton className="h-9 w-full" />
              <Skeleton className="h-9 w-full" />
            </CardContent>
          </Card>
        </div>
      </div>
    )
  }

  if (sessionError) {
    return (
      <SessionRetry
        message={sessionError}
        onRetry={refreshSession}
        onLogout={logout}
      />
    )
  }

  if (isAuthenticated) {
    return (
      <div className="flex min-h-svh w-full items-center justify-center p-6">
        <p className="text-sm text-muted-foreground">正在跳转...</p>
      </div>
    )
  }

  return (
    <div className="relative flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="absolute top-4 right-4 z-10">
        <ThemeToggle />
      </div>
      <div className="w-full max-w-sm">
        <LoginForm />
      </div>
    </div>
  )
}
